import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyB9ucgF-nIRR8HAzJrx_PWFzAZlRUNBrsM",
  authDomain: "greenline-580b9.firebaseapp.com",
  projectId: "greenline-580b9",
  storageBucket: "greenline-580b9.firebasestorage.app",
  messagingSenderId: "52050154765",
  appId: "1:52050154765:web:d378aacbe86c7d7e6dcc44",
  measurementId: "G-Q4RQWPRMSW",
};

const app = initializeApp(firebaseConfig);

// App Check (reCAPTCHA v3) — activates only once a site key is provided, so it
// never breaks local/dev before App Check is registered in the Firebase console.
// Set REACT_APP_RECAPTCHA_SITE_KEY in the build env, then flip APP_CHECK_ENFORCE
// on the functions to require it.
const appCheckSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (appCheckSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);